import { Theme } from '@mui/material'

export const ROW_HEADERS = {
  ROUND_ONE: 'R1',
  ROUND_TWO: 'R2',
  ROUND_THREE: 'R3',
  ROUND_FOUR: 'R4',
  PAR: 'PAR',
  YRD: 'YRD'
} as const

export const EMPTY_VALUE = '-' as const

export type RowHeaderType = keyof typeof ROW_HEADERS
export type RowHeaderValue = (typeof ROW_HEADERS)[RowHeaderType]

export const getScoreBackground = (score: number, isScoreRow: boolean, theme: Theme): string => {
  if (!isScoreRow) {
    return 'inherit'
  }

  switch (score) {
    case 1:
      return theme.palette.golfColours.bogey
    case -1:
      return theme.palette.golfColours.birdie
    default:
      if (score > 1) {
        return theme.palette.golfColours.doubleBogey
      } else if (score < -1) {
        return theme.palette.golfColours.eagle
      }
      return 'inherit'
  }
}

export const getTextColor = (background: string, theme: Theme): string => {
  if (!background || background === 'inherit') {
    return theme.palette.text.primary
  }

  const golfColors = [
    theme.palette.golfColours.eagle,
    theme.palette.golfColours.birdie,
    theme.palette.golfColours.bogey,
    theme.palette.golfColours.doubleBogey
  ]

  if (golfColors.includes(background)) {
    return theme.palette.mode === 'dark' ? theme.palette.grey[50] : theme.palette.grey[900]
  }

  return theme.palette.text.primary
}

export const getHoleValue = (
  hole: { holePar?: number; holeScore?: number; holeStrokes?: number; holeYardage?: number },
  rowType: RowHeaderType | RowHeaderValue
): string | number => {
  if (!hole) return EMPTY_VALUE

  const rowValue =
    typeof rowType === 'string' && rowType in ROW_HEADERS
      ? ROW_HEADERS[rowType as RowHeaderType]
      : rowType

  switch (rowValue) {
    case ROW_HEADERS.PAR:
      return hole.holePar ?? EMPTY_VALUE
    case ROW_HEADERS.YRD:
      return hole.holeYardage ? Math.round(hole.holeYardage * 1.09361).toString() : EMPTY_VALUE
    default:
      return hole.holeStrokes ?? EMPTY_VALUE
  }
}
